const Loading = () => {
  return (
    <div className='loading-dot' />
  )
}

export default Loading